import {
    VuexModule,
    Module,
    getModule,
    Mutation,
    Action,
} from 'vuex-module-decorators';
import store from '@/store';
import { getNumberDenouncesPending, getNumberOptionsPending,getNumberBookingsPending } from '@/api/api';
import AuthModule from './AuthModule';

interface State {
    pendingDenounces: number;
    pendingOptions: number;
}

@Module({ dynamic: true, store, name: 'sidebar', namespaced: true })
class SidebarModule extends VuexModule implements State {
    public pendingDenounces: number = 0;
    public pendingOptions: number = 0;
    public pendingBookings:number = 0;
    public initialized = false;

    @Mutation
    setInitialized() {
        this.initialized = true;
    }

    @Mutation
    setPendingDenouces(value: number) {
        this.pendingDenounces = value;
    }

    @Action
    async fetchPendingDenounces() {
        const { data } = await getNumberDenouncesPending();
        this.context.commit('setPendingDenouces', data);
    }

    @Mutation
    setPendingOptions(value: number) {
        this.pendingOptions = value;
    }

    @Action
    async fetchPendingOptions() {
        const { data } = await getNumberOptionsPending();
        this.context.commit('setPendingOptions', data);
    }

    @Mutation
    setPendingBookings(value: number) {
        this.pendingBookings = value;
    }

    @Action
    async fetchPendingBookings() {
        const { data } = await getNumberBookingsPending();
        this.context.commit('setPendingBookings', data);
    }

    @Action
    async init(): Promise<void> {
        if (this.initialized) {
            return;
        }
        this.context.commit('setInitialized');
        this.fetchPendingDenounces();
        this.fetchPendingOptions();
        this.fetchPendingBookings();
        const interval = setInterval(() => {
            if (AuthModule.roles.includes('ROLE_ADMIN')) {
                this.fetchPendingDenounces();
                this.fetchPendingOptions();
                this.fetchPendingBookings();
            } else {
                clearInterval(interval);
                this.context.commit('setInitialized', false);
            }
        }, 60000);
    }
}

export default getModule(SidebarModule);
